import React from 'react';
import classNames from 'classnames';

import Select, { SelectOption, SelectGroup } from '../select';

export type MoreSelectOption = SelectOption;
export type MoreSelectGroup = SelectGroup;

export interface MoreSelectProps {
  options: (MoreSelectOption | MoreSelectGroup)[];
  selectedValues: string[];
  onChange: (values: string[]) => void;
  disabled?: boolean;
  className?: string;
  multiSelect?: boolean;
}

const MoreSelect: React.FC<MoreSelectProps> = ({
  options,
  selectedValues,
  onChange,
  disabled = false,
  className,
  multiSelect = false,
}) => {
  const renderSelectedLabel = (selected: MoreSelectOption | MoreSelectGroup | undefined) => {
    return selected ? selected.label : 'More';
  };

  return (
    <Select
      options={options}
      selectedValues={selectedValues}
      onChange={onChange}
      disabled={disabled}
      className={classNames('more-select', className)}
      multiSelect={multiSelect}
      placeholder="More"
      showCheckbox={multiSelect}
      showSelectedIcon={true}
      renderSelectedLabel={renderSelectedLabel}
    />
  );
};

export default MoreSelect;
